export enum CatchWeightOptions {
    NotVerified = 0,
    Verified = 1,
    Add = 2,
    Edit = 3,
    Delete = 4,
    Undo = 5
}